import { Box, Link, Text } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { LINKS } from 'src/apps/invest/config';

export const Disclosure: React.FC = () => (
  <Box>
    <Text as="p" pb="5" fontFamily={FontFamily.NEUE_HAAS_DISPLAY_ROMAN}>
      <Text as="span" fontFamily={FontFamily.NEUE_HAAS_DISPLAY_BOLD}>
        Investing in real estate involves risks including the potential loss of principal
      </Text>
      . A real estate portfolio is subject to risks similar to those associated with the direct ownership of real estate
      and real estate debt, as the investments are sensitive to factors such as changes to real estate values and
      property taxes, interest rates, cash flow of underlying real estate assets, supply and demand, and the management
      skill and credit worthiness of the issuer & borrowers. Portfolios concentrated in real estate assets may
      experience price volatility and other risks associated with non-diversification. US real estate investments may
      also be affected by tax and regulatory requirements. Economic factors, market conditions, and investment
      strategies will affect the performance of any portfolio and there is no assurance that a portfolio will match or
      outperform any particular benchmark. There is no guarantee that investment objectives will be achieved, and past
      performance is not indicative of future results.
    </Text>
    <Text as="p" pb="5">
      <Text as="span" fontFamily={FontFamily.NEUE_HAAS_DISPLAY_BOLD}>
        Concreit Inc.
      </Text>
      owns this website and certain apps (the "Services"). Concreit Fund Management LLC ("Concreit"), an investment
      adviser registered with the Securities and Exchange Commission (“SEC”), operates the Services. By using the
      Services, you accept our{' '}
      <Link href={LINKS.TERMS} target="_blank" color="#7ba3d1">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href={LINKS.PRIVACY_POLICY} target="_blank" color="#7ba3d1">
        Privacy Policy
      </Link>
      . Concreit's investment advisory services are available only to residents of the United States in jurisdictions
      where Concreit is registered. Past performance is no guarantee of future results. Any historical returns, expected
      returns [or probability projections] are hypothetical in nature and may not reflect actual future performance.
    </Text>
    <Text as="p" pb="5">
      Refer to Concreit’s{' '}
      <Link href={LINKS.FORM_ADV_PART_2_BROCHURE} target="_blank" color="#7ba3d1">
        Disclosure Brochure
      </Link>{' '}
      for more information. Certain investments are not suitable for all investors. Before investing, consider your
      investment objectives and Concreit’s fees. The rate of return on investments can vary widely over time, especially
      for long term investments. Investment losses are possible, including the potential loss of all amounts invested.
      For more information, see our disclosures. Contact: 1201 3rd Ave, Suite 2200, Seattle, WA 98101.
    </Text>
    <Text as="p" pb="5">
      Information provided by Concreit Support and our staff is for informational and general educational purposes only
      and is not investment or financial advice. Neither Concreit nor any of its affiliates provide tax advice and do
      not represent in any manner that the outcomes described herein will result in any particular tax consequence.
      Prospective investors should confer with their personal tax advisors regarding the tax consequences based on their
      particular circumstances. Neither Concreit nor any of its affiliates assume responsibility for the tax
      consequences for any investor of any investment.
    </Text>
  </Box>
);
